import SimpleBar from 'simplebar'

$('.js-simplebar').each((index, el) => new SimpleBar(el))

// $('.js-simplebar .simplebar-content-wrapper').on('scroll', () => {
//   if ($('.js-datepickerFrom').length > 0) {
//     $('.js-datepickerFrom').data('datepicker').hide()
//   }
// })
